module.exports = __webpack_public_path__ + "img/chicken.d6503b6d.svg";